import React, { useContext } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { permissionsService } from "services/permissions.service";
import { MembershipContext } from "hoc/membership-data";

const PermissionGuard = ({ requiredPermission }) => {
  const { teams } = useContext(MembershipContext);
  const { team_id } = useParams(); // Get team_id from URL parameters

  const team = teams.find((t) => t.team_id === team_id); // Find the team by team_id
  const hasPermission =
    team && permissionsService.hasPermission(requiredPermission, team.team_id);

  if (!hasPermission) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PermissionGuard;
